import { useI18n } from '@/hooks/useI18n';
import type { TranslationKey } from '@/i18n';
import type { RequestStatus } from '@/types';

const labels: Record<RequestStatus, TranslationKey> = {
  draft: 'status.draft',
  review: 'status.review',
  approved: 'status.approved',
  rejected: 'status.rejected',
};

type StatusTone = 'info' | 'warning' | 'success' | 'neutral';

interface StatusPillProps {
  status?: RequestStatus;
  tone?: StatusTone;
  children?: React.ReactNode;
}

export const StatusPill = ({ status, tone = 'neutral', children }: StatusPillProps) => {
  const { t } = useI18n();
  const label = status ? t(labels[status]) : children;
  return (
    <span className="status-pill" data-status={status ?? tone} data-tone={tone}>
      {label}
    </span>
  );
};
